import styled from "styled-components";
import { SonharMorarContainerLogoProps } from "./SonharMorarLogo.types";

export const SonharMorarContainerLogo = styled.div<SonharMorarContainerLogoProps>`
  background-color: ${(props: { $backgroundcolor: string }) =>
    props.$backgroundcolor};
  height: 96px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  padding: 0 24px;
  @media (min-width: 768px) {
    height: 158px;
  }

  .sonharmorar__logo {
    width: 850px;

    @media (min-width: 768px) {
      justify-items: center;
    }

    img {
      width: fit-content;
      height: 78px;
      object-fit: contain;

      @media (min-width: 768px) {
        height: 138px;
      }
    }
  }
`;
